import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {
  /*const [urlWeb] = useState("http://localhost:3000/");
  const [urlServices] = useState("http://localhost:3001/");*/

  const [urlWeb] = useState("https://gga.usameweb.com/");
  const [urlServices] = useState("https://ggaapi.usameweb.com/");

  /*  ### PLACETOPAY ### */
  const [LightboxPlaceToPay] = useState(
    "https://checkout.placetopay.com/lightbox.min.js"
  );

  /*  ### API CONTABLE (Confiable) ### */
  const [ViewFactGenerate] = useState(
    "https://app.confiable.com.ec/Ventas/Facturas/GenerarRide/?id="
  );
  /* ###################################################################################### */

  const [UserAuth, setUserAuth] = useState(() => {
    const storedSession = localStorage.getItem("Session");
    return storedSession
      ? { Session: storedSession }
      : {
          id: "",
          Session: null,
          name: "",
          lastname: "",
          allname: "",
          documentId: "",
          email: "",
          avatar: null,
          companyId: "",
          commissionPercentage: "",
          profile_id: "",
          profile_name: "",
          createdAt: "",
          gender: "",
          status: "",
          lastLogin: "",
          cashDiscount: "",
          logo: null,
        };
  });

  useEffect(() => {
    const fetchData = async () => {
      const datavalue = { token: localStorage.getItem("Session") };

      if (localStorage.getItem("Session") !== null) {
        try {
          const response = await axios.post(
            `${urlServices}users/validate-token`,
            datavalue
          );

          setUserAuth({
            ...UserAuth,
            id: response.data.user.id,
            name: response.data.user.name,
            lastname: response.data.user.lastName,
            allname:
              response.data.user.name + " " + response.data.user.lastName,
            documentId: response.data.user.documentId,
            email: response.data.user.email,
            avatar:
              response.data.user.avatar === ""
                ? null
                : response.data.user.avatar,
            companyId: response.data.user.companyId,
            commissionPercentage: response.data.user.commissionPercentage,
            profile_id: response.data.user.profileId,
            profile_name: response.data.user.profile.name,
            createdAt: response.data.user.createdAt,
            gender: response.data.user.genderId,
            status: response.data.user.status,
            lastLogin:
              response.data.user.logSystem.length > 0
                ? response.data.user.logSystem[0].createdAt
                : "",
            cashDiscount: response.data.user.company
              ? response.data.user.company.cashDiscount
              : null,
            logo: response.data.user.company
              ? response.data.user.company.logo
              : null,
          });
        } catch (error) {
          // Manejar errores aquí, por ejemplo, mostrar un mensaje de error o realizar alguna acción específica
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, []);

  const LoginAuth = (userData) => {
    setUserAuth({
      ...UserAuth,
      id: userData.user.id,
      Session: userData.token,
      name: userData.user.name,
      lastname: userData.user.lastName,
      allname: userData.user.name + " " + userData.user.lastName,
      documentId: userData.user.documentId,
      email: userData.user.email,
      avatar: userData.user.avatar === "" ? null : userData.user.avatar,
      companyId: userData.user.companyId,
      commissionPercentage: userData.user.commissionPercentage,
      profile_id: userData.user.profileId,
      profile_name: userData.user.profile.name,
      createdAt: userData.user.createdAt,
      gender: userData.user.genderId,
      status: userData.user.status,
      lastLogin:
        userData.user.logSystem.length > 0
          ? userData.user.logSystem[0].createdAt
          : "",
      cashDiscount: userData.user.company
        ? userData.user.company.cashDiscount
        : null,
      logo: userData.user.company ? userData.user.company.logo : null,
    });
    localStorage.setItem("Session", userData.token);
  };

  const LogoutAuth = () => {
    setUserAuth({
      ...UserAuth,
      id: "",
      Session: null,
      name: "",
      lastname: "",
      allname: "",
      documentId: "",
      email: "",
      avatar: null,
      companyId: "",
      commissionPercentage: "",
      profile_id: "",
      profile_name: "",
      createdAt: "",
      gender: "",
      status: "",
      lastLogin: "",
      cashDiscount: "",
      logo: null,
    });
    localStorage.removeItem("Session");
  };
  const UpdateUserAuth = (newUserData) => {
    setUserAuth({
      ...UserAuth,
      ...newUserData,
    });
  };

  return (
    <Provider
      value={{
        urlServices,
        UserAuth,
        LoginAuth,
        LogoutAuth,
        UpdateUserAuth,
        urlWeb,
        LightboxPlaceToPay,
        ViewFactGenerate,
      }}
    >
      {children}
    </Provider>
  );
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
